import { useState } from "react";
import YellowBox4 from "../../assets/images/yellow-box-4.png";
import YellowBox5 from "../../assets/images/yellow-box-5.png";

const UnileverDigitalTeam = (props) => {
  const [teams] = useState([
    {
      eng: {
        title: "Sales Technology & Digital Transformation",
        description:
          "Our technology and digitalizing team use various digital tools to empower sales teams and build virtual  bridges between businesses. From leading the Customer Business Development environment with smart cabinets, software and hardware upgrades, to saving time from manually operating processes with automation and to manage the cabinet fleet, our Technology and Digitalization Team’s expertise over the various businesses is unlimited. Above all, this team is the pioneer of change management that keeps Unilever adaptive to manage operations in motion with agility and responsiveness.",
      },
      tr: {
        title: "Satış Teknolojisi & Dijital Dönüşüm",
        description:
          "Teknoloji ve dijitalleşme ekibimiz, satış ekiplerine güçlü öngörüler sağlamak ve iş birimleri arasında dijital köprüler kurmak için çeşitli dijital araçlar kullanıyor. Akıllı kabinler, yazılım ve donanım geliştirmeleri ile Müşteri İş Geliştirme ortamına öncülük etmekten tutun, otomasyonla manuel olarak yürütülen süreçlerin dijitalize edilmesi ve kabin filosunu yönetmeye kadar, Teknoloji ve Dijitalleşme ekibimiz çeşitli iş birimleri üzerinde derin bir yetkinliğe sahiptir. En önemlisi de bu ekip, Unilever'i halihazırdaki operasyonları çeviklik ve yanıt verebilirlik ilkesi ile yönetmeye uyumlu tutan değişim yönetiminde öncü rol üstlenmektedir.",
      },
    },
    {
      eng: {
        title: "Digital Marketing, Media &Commerce",
        description:
          "DMC team integrates Digital Marketing, Media and dCommerce to respond on the convergence of Media and Commerce trend. Our key mission is to be Unilever’s fully integrated growth driving digital acceleration engines that drive our brands to be unmissable through planning and delivery of world class seamless & personalized Digital Marketing, Media and Digital Commerce omnichannel experience for our consumers. DMC unlocks sustainable growth through recognising the convergence of digital marketing, media and sales.",
      },
      tr: {
        title: "Dijital Pazarlama, Medya & Ticaret",
        description:
          "DMC ekibi, djital medya, pazarlama ve e-ticaret kanallarının birbiri içerisine geçmesinin bir yansıması olarak kuruldu. Ekibimizin ana misyonu; tüketicilerimizin, markalarımızla ilk temas noktasından satış noktasına, medya veya dijital varlıklarımız ile uçtan uca en iyi kişiselleştirilmiş deneyimi  yaşamalarını sağlayarak, Unilever’in uçtan uca entegre büyümesine ivme kazandırmaktır.  DMC ekibi dijital pazarlama, medya ve ticaretin iç içe geçmesini sağlayarak Unilever’in sürdürülebilir büyümesinin önü açmaktadır.",
      },
    },
    {
      eng: {
        title: "Data&Analytics",
        description:
          "Our Data & Analytics team leads the path for Unilever to become data-intelligent by delivering analytics products at scale and by enabling business units, business operations and leadership teams to turn data into insights, actions and decisions at a faster pace than ever before to achieve competitive edge for Unilever. D&A team ensures that discovered insights are driving incremental and purposeful growth by meeting the needs of our consumers, customers and employees.",
      },
      tr: {
        title: "Veri&Analitik",
        description:
          "Veri & Analitik ekibimiz; geniş ölçekte analitik ürünler sunarak, verileri iç görülere dönüştürmek amacıyla iş birimlerini, operasyonlarını ve liderlik ekiplerini ulaşılabilir kılarak ve Unilever için rekabet avantajı elde etmek adına her zamankinden daha hızlı  eylem ve karar tempoları ile çalışarak veriye dayalı bir Unilever için dönüşüm yoluna liderlik eder. D&A (Bu kısaltma da çevrilmeli mi :D) ekibi; keşfedilen iç görülerin tüketicilerimizin, müşterilerimizin ve çalışanlarımızın ihtiyaçlarını karşılayarak artan ve amaca yönelik büyümeyi teşvik etmesini sağlar.",
      },
    },
  ]);

  return (
    <section
      id={
        props.currentLang === "eng"
          ? "unilever-dmc-team"
          : "unilever-dijital-ekip"
      }
      className="w-full flex justify-center bg-[#7705BC] py-28 relative"
    >
      <div className="w-4/5 max-w-screen-xl flex flex-col space-y-10">
        <div className="text-center">
          <h2
            data-aos="fade-down"
            className="text-3xl md:text-5xl lg:text-[3.5rem] lg:leading-[4rem] text-white font-bold"
          >
            {props.currentLang === "eng"
              ? "UNILEVER DIGITAL TEAM"
              : "UNILEVER DİJİTAL EKİP"}
          </h2>
        </div>
        <div className="flex flex-col lg:flex-row lg:space-x-5 space-y-5 lg:space-y-0">
          <div className="w-full lg:w-1/2 space-y-5">
            <div data-aos="fade-down" className="w-full p-1 md:p-3">
              <h3 className="text-2xl text-[#00D7C4] font-bold mb-3">
                {props.currentLang === "eng"
                  ? teams[0].eng.title
                  : teams[0].tr.title}
              </h3>
              <p className="text-sm md:text-base font-normal text-white">
                {props.currentLang === "eng"
                  ? teams[0].eng.description
                  : teams[0].tr.description}
              </p>
            </div>
            <div data-aos="fade-down" className="w-full p-1 md:p-3">
              <h3 className="text-2xl text-[#00D7C4] font-bold mb-3">
                {props.currentLang === "eng"
                  ? teams[1].eng.title
                  : teams[1].tr.title}
              </h3>
              <p className="text-sm md:text-base font-normal text-white">
                {props.currentLang === "eng"
                  ? teams[1].eng.description
                  : teams[1].tr.description}
              </p>
            </div>
          </div>
          <div className="w-full lg:w-1/2 space-y-5">
            <div data-aos="fade-down" className="w-full p-1 md:p-3">
              <h3 className="text-2xl text-[#00D7C4] font-bold mb-3">
                {props.currentLang === "eng"
                  ? teams[2].eng.title
                  : teams[2].tr.title}
              </h3>
              <p className="text-sm md:text-base font-normal text-white">
                {props.currentLang === "eng"
                  ? teams[2].eng.description
                  : teams[2].tr.description}
              </p>
            </div>
          </div>
        </div>
      </div>
      <img
        className="absolute w-[50px] md:w-[90px] left-10 md:left-auto md:right-[28%] bottom-3 lg:bottom-4 z-[1] animate-[wiggle_10s_ease-in-out_infinite]"
        src={YellowBox4}
        alt="yellow box"
      />
      <img
        className="absolute w-[120px] sm:w-[160px] md:w-[200px] lg:w-[230px] -top-14  lg:-top-20 left-[12%] animate-[wiggle_10s_ease-in-out_infinite]"
        src={YellowBox5}
        alt="yellow box"
      />
    </section>
  );
};
export default UnileverDigitalTeam;
